const API_URL = process.env.REACT_APP_API_URL || 'https://pmapi.acts-int.net';
//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export default API_URL;
